<template>
<div class="header-wrapper">
  <trial-modal v-if="isTrial" />
  <div class="header"
       :class="{'header_print': printMode, 'header_shrunk': isShrunk}">
    <div class="header__logo-wrap"
         @contextmenu.stop.prevent="goHome"
         :class="{'header__logo-wrap_collapsed': isLogoCollapsed}" @click="goHome">
      <!--        TODO: replace with real logo! -->
      <img class="header__logo" src="@/assets/rfx-logo.svg" alt="Audiencekey">
      <span class="header__logo-text"
            v-if="!isLogoCollapsed">Audience Key</span>
    </div>
    <div class="header__right"
         :class="{'header__left_hidden': !clientIsReady}"
         v-show="selectedClient">
      <base-bread-crumbs/>
      <base-select v-if="isSelectVisible"
                   borderLess
                   isGreyArrowColor
                   :titleStyle="{
                      color: '#2f404e !important',
                      fontSize: '12px',
                      fontWeight: 500,
                      lineHeight: '20px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      height: 'fit-content',
                      margin: 'auto 0',
                      display: 'inline-block' }"
                   class="header__select"
                   :options="options"
                   :disabled="isSelectDisabled"
                   :headerStyle="{ width: '170px' }"
                   v-model="selectedMsv"
                   @change="changeMsv"/>
      <router-link v-else-if="isKeywordCensus"
        class="header__urlc-link"
        to="/strategy/url-census"
        target="_blank">
        <span>URLs</span>
      </router-link>
      <router-link v-else-if="isUrlCensus"
        class="header__urlc-link"
        to="/strategy/keyword-census"
        target="_blank">
        <span>Keywords</span>
      </router-link>
    </div>
  </div>
</div>
</template>

<script>
import MainLayout from '../MainLayout'
import TrialModal from '../features/trial/TrialModal'
import { mapState } from 'vuex'

/**
 * Header contains logo and breadcrumbs
 * Used in the {@link MainLayout}
 */
export default {
  name: 'TheHeader',
  components: {
    TrialModal
  },
  props: {
    clientIsReady: {
      type: Boolean,
      default: true
    },
    printMode: Boolean,
    isShrunk: Boolean,
    isLogoCollapsed: Boolean
  },
  data () {
    return {
      selectedMsv: 1
    }
  },
  computed: {
    ...mapState({
      userRoles: 'userRoles'
    }),
    ...mapState(['isAgentModeEnabled']),
    ...mapState('rankZoneCommon', {
      isSelectDisabled (state) {
        return state.msv.length < 2
      },
      options (state) {
        return state.msv.map(i => ({ label: 'MSV: ' + i.label, value: i._id }))
      },
      isTrial (state) {
        return !!state.trial.trialEndDate
      }
    }),
    isSelectVisible () {
      const pathToUpdate = ['/reports/', '/url-planner', '/content-briefs/']
      return pathToUpdate.some(i => this.$route.fullPath.includes(i)) && this.options.length && !this.isAgentModeEnabled
    },
    isKeywordCensus () {
      return this.$route.name === 'keyword-census'
    },
    isUrlCensus () {
      return this.$route.name === 'url-census'
    }
  },
  watch: {
    options (value) {
      const msv = JSON.parse(localStorage.getItem('msv')) || {}
      const selectedMsv = msv[this.clientId] || 1
      this.selectedMsv = value.find(i => i.value === selectedMsv) ? selectedMsv : 1
    }
  },
  methods: {
    goHome () {
      // let name
      let url = window.location.origin + '/dashboard#/'
      if (this.userRoles.some(role => ['agency_user', 'agency_admin', 'admin'].includes(role))) {
        // name = 'keyword_census'
        url += 'strategy/keyword-census'
      } else {
        // name = 'Overview'
        url += 'reports/rank-zone/overview'
      }
      // if (newTabOpen) {
      window.open(url, '_blank')
      // } else {
      //   this.$router.push({ name })
      // }
    },
    changeMsv (value) {
      if (!this.clientId) {
        return
      }

      const msv = JSON.parse(localStorage.getItem('msv')) || {}

      msv[this.clientId] = value
      localStorage.setItem('msv', JSON.stringify(msv))

      location.reload()
    }
  }
}
</script>

<style scoped lang="scss">
  .header {
    display: flex;
    background-color: $rfx-background-color;
    height: $rfx-header-height-base;
    position: relative;
    box-sizing: border-box;

    // &_shrunk {
    //   height: $rfx-header-height-collapsed;
    // }

    &__block {
      display: flex;
      align-items: center;
      white-space: nowrap;
    }

    &__logo-wrap {
      display: flex;
      align-items: center;
      width: $rfx-navbar-width-base;
      border-right: 1px solid $rfx-almost-white-darker;
      background-color: #fff;
      box-sizing: border-box;
      /*<!--margin: 0 $rfx-side-gap 0 (-$rfx-side-gap);-->*/
      padding-left: 32px;
      cursor: pointer;

      &_collapsed {
        width: 90px;
        /*margin-right: 70px;*/
      }
    }

    &__logo {
      display: block;
      width: 26px;
      height: 26px;
      overflow: hidden;
    }

    &__logo-text {
      font-size: 23px;
      font-weight: 600;
      margin-left: 7px;
    }

    &__left {
      font-weight: 500;
      font-size: 18px;
      display: flex;
      align-items: center;
      flex: 1 1;
      max-width: 50%;

      &_hidden {
        visibility: hidden;
      }
    }

    &__select {
      margin-left: auto;
    }

    &__urlc-link {
      margin-left: auto;
      color: $rfx-dark-march;
      font-size: 12px;
      text-decoration: none;
    }

    &__right {
      display: flex;
      align-items: center;
      flex: 1 1;
      margin-left: $rfx-side-gap;
      margin-right: $rfx-side-gap;
      font-weight: 500;
      font-size: 18px;
      border-bottom: 1px solid $rfx-almost-white-darker;
    }

    &__project {
      padding-left: 10px;
      color: $rfx-medium-grey;
      font-weight: 600;
      position: relative;
      cursor: pointer;
      padding-right: 20px;

      &::after {
        display: block;
        position: absolute;
        content: '';
        width: 6px;
        height: 6px;
        border-left: 2px solid $rfx-blue;
        border-bottom: 2px solid $rfx-blue;
        transform: rotate(-45deg) translate(-12px, 10px);
        top: -10px;
        right: 0;
      }
    }
  }

  .select {

    &__list-wrap {
      position: absolute;
      min-width: 100%;
      max-width: 350px;
      cursor: default;
      top: 100%;
      left: 0;
    }

    &__overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 1000;
    }

    &__list {
      margin: 0;
      padding: 0;
      list-style-type: none;
      background-color: #fff;
      border-bottom-left-radius: $rfx-default-border-radius;
      border-bottom-right-radius: $rfx-default-border-radius;
      box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.3);
      z-index: 1001;
      position: absolute;
      top: 10px;
      right: 0;
    }

    &__projects-list {
      padding: 0;
      overflow-x: hidden;
      overflow-y: auto;
      max-height: calc(100vh - 290px);
    }

    &__item {
      display: block;
      padding: 0 20px;
      height: 30px;
      line-height: 30px;
      color: #000;
      font-size: 12px;
      cursor: pointer;
      @include ellipsis;

      &_active,
      &:hover {
        background-color: $rfx-light-blue;
        color: #fff;
      }

      &:first-child {
        border-top: 2px solid $rfx-blue-medium;
      }

      &:last-child {
        border-bottom-left-radius: $rfx-default-border-radius;
        border-bottom-right-radius: $rfx-default-border-radius;
      }
    }

  }

</style>
